import { Customer } from 'pejer/src/tables/Customer'
import { PaymentEnvironment } from 'pejer/src/tables/Global'
import { PaymentProvider } from 'pejer/src/tables/Platform'

export interface CheckoutResponse {
  paymentReferenceID: string
  grossAmount: number
  description: string

  stripe: {
    publishableKey: string
    paymentIntentId: string
    clientSecret: string
    /**
     * Stripe currency:
     * Three-letter <a href="https://www.iso.org/iso-4217-currency-codes.html">ISO currency
     * code</a>, in lowercase. Must be a <a href="https://stripe.com/docs/currencies">supported
     * currency</a>.
     */
    currency: string
  }
  bambora?: {
    sessionToken: string
  }
  currency: string

  // swedbankPay: {
  //   scriptUrl: string
  // }

  paymentMethodProviders: {
    [x in AvailablePaymentMethods]?: PaymentProvider
  }

  customer: Customer.Full
  successUrl: string
  failedUrl: string

  orderDetails: OrderDetails
  environment: PaymentEnvironment
  paymentMethods: AvailablePaymentMethods[]
}

/**
 * The gross shipping cost of the order.
 * Specified in the smallest unit of the currency (for example 100 for 1 NOK)
 */
export interface OrderDetails {
  grossShippingCost: number

  /**
   * Tax on the shipping cost in percentage.
   * E.g. A tax of 25% is 25.0
   */
  shippingTaxPercentage: number

  /**
   * The product lines displayed in the checkout and invoice.
   */
  productLines: ProductLine[]
}

export interface ProductLine {
  /** The name of the product line. */
  name: string

  /** Description of the product line. */
  description?: string

  /**
   * The gross cost of the product line. This includes tax and is the total price
   * of the product line, it is not multiplied by the quantity field.
   * Specified in the smallest unit of the currency (for example 100 for 1 NOK)
   */
  grossCost: number

  /** The quantity of the product line. */
  quantity: number

  /**
   * Tax on the product line in percentage.
   * E.g. A tax of 25% is 25.0
   */
  taxPercentage: number

  /** The image URL of the product line. */
  imageUrl?: string

  /**
   * External ID to identify which service or product was purchased.
   */
  externalID?: string

  productID?: string

  paymentVersionNumber?: number

  /**
   * type
   */
  productLineType?: 'Product' | 'Interest' | 'Fee' | 'Credit' | 'ReminderFee' | 'DebtCollectionFee'
}

export enum AvailablePaymentMethods {
  CreditCard = 'CreditCard',
  Invoice = 'Invoice',
  Bank2Bank = 'Bank2Bank',
  Vipps = 'Vipps',
  ApplePay = 'ApplePay',
  GooglePay = 'GooglePay',
  Bambora = 'Bambora',
}

export enum VerifyPaymentStatus {
  Success = 'Success',
  Failed = 'Failed',
  Pending = 'Pending',
}

export interface CheckoutVerifyPaymentResponse {
  paymentReferenceID: string
  status: VerifyPaymentStatus
  message: string
  redirectUrl: string | null
}
